import React, { useCallback, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import style from './Toast.module.css'

function Toast({ show, message, onClose, duration = 3000 }) {
    const timerRef = useRef(null)
    const onCloseRef = useRef(onClose)
    onCloseRef.current = onClose

    const clearTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current)
            timerRef.current = null
        }
    }, [])

    const startTimer = useCallback(() => {
        clearTimer()
        timerRef.current = setTimeout(() => {
            onCloseRef.current && onCloseRef.current()
        }, duration)
    }, [clearTimer, duration])

    useEffect(() => {
        if (!show) return
        startTimer()
        return clearTimer
    }, [show, message, startTimer, clearTimer])

    if (!show) return null

    return ReactDOM.createPortal(
        <div
            className={style.toast}
            role="status"
            onMouseEnter={clearTimer}
            onMouseLeave={startTimer}
        >
            {message}
        </div>,
        document.body
    )
}

export default Toast
